module.exports = __webpack_public_path__ + "static/images/drag-handle-dots.pC8Q2bX.svg";